import {
  Stack,
  Typography,
  Box,
  Button,
  Divider,
  TextField,
  InputAdornment,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import SportsGymnasticsIcon from "@mui/icons-material/SportsGymnastics";
import LocalOfferIcon from "@mui/icons-material/LocalOffer"; // آیکون جدید برای تخفیف
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  useGetSportsQuery,
  useGetProvincesQuery,
  useGetCitiesByProvinceQuery, // <-- هوک جدید
  useGetAreasByCityQuery, // <-- هوک جدید
} from "../../../../../Store/api/queries";

// کامپوننت کمکی بخش کلاپس‌شونده
const FilterSection = ({ title, icon, children }) => (
  <Box component="section">
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        backgroundColor: "transparent",
        "&:before": { display: "none" },
        "&.Mui-expanded": { margin: 0 },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "rgba(255,255,255,0.5)" }} />}
        sx={{
          padding: 0,
          minHeight: 40,
          "& .MuiAccordionSummary-content": { margin: "12px 0" },
          "&.Mui-expanded": { minHeight: 40 },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {icon}
          <Typography
            variant="body2"
            fontWeight={500}
            sx={{ color: "rgba(255,255,255,0.9)" }}
          >
            {title}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: "0 0 16px 0" }}>
        {children}
      </AccordionDetails>
    </Accordion>
    <Divider sx={{ borderColor: "rgba(255,255,255,0.06)" }} />
  </Box>
);

// انتقال استایل‌ها به بیرون از کامپوننت برای پرفورمنس بهتر
const textFieldStyles = {
  "& .MuiOutlinedInput-root": {
    color: "rgba(255,255,255,0.9)",
    fontSize: "0.875rem",
    "& fieldset": {
      borderColor: "rgba(255,255,255,0.12)",
      borderRadius: "10px",
    },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.25)" },
    "&.Mui-focused fieldset": { borderColor: "primary.main" },
  },
  "& .MuiSvgIcon-root": { color: "rgba(255,255,255,0.5)" },
};

export default function SidebarContent({
  searchQuery,
  setSearchQuery,
  selectedSport,
  setSelectedSport,
  selectedProvince,
  setSelectedProvince,
  selectedCity,
  setSelectedCity,
  selectedArea,
  setSelectedArea,
  isDiscount,
  setIsDiscount,
}) {
  // فچ کردن دیتاهای داینامیک
  const { data: sportsData } = useGetSportsQuery({ limit: 100 });
  const { data: provincesData } = useGetProvincesQuery({
    isActive: true,
    limit: 100,
  });

  // 👇 درخواست‌های جدید بر اساس روت‌های اختصاصی بک‌اند
  const { data: citiesData } = useGetCitiesByProvinceQuery(
    selectedProvince?._id,
    { skip: !selectedProvince },
  );

  const { data: areasData } = useGetAreasByCityQuery(selectedCity?._id, {
    skip: !selectedCity,
  });

  // 👇 استخراج لیست‌ها بر اساس ساختار جدید بک‌اند
  const sportsList =
    sportsData?.data?.docs || sportsData?.data || sportsData || [];
  const provincesList =
    provincesData?.data?.docs || provincesData?.data || provincesData || [];

  // دقت کنید ساختار ریسپانس روت جدید اینگونه است: data.data.cities
  const citiesList =
    citiesData?.data?.cities || citiesData?.data || citiesData || [];

  // دقت کنید ساختار ریسپانس روت جدید اینگونه است: data.data.areas
  const areasList =
    areasData?.data?.areas || areasData?.data || areasData || [];

  const getSelectedCount = () => {
    let count = 0;
    if (searchQuery) count++;
    if (selectedSport) count++;
    if (selectedProvince) count++;
    if (selectedCity) count++;
    if (selectedArea) count++;
    return count;
  };

  const resetFilters = () => {
    setSearchQuery("");
    setSelectedSport(null);
    setSelectedProvince(null);
    setSelectedCity(null);
    setSelectedArea(null);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* هدر */}
      <Box
        sx={{
          p: { xs: 2, md: 2.5 },
          borderBottom: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <Typography variant="subtitle1" fontWeight={600} sx={{ color: "#fff" }}>
          پیدا کردن باشگاه مناسب
        </Typography>
        <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.5)" }}>
          {getSelectedCount()} فیلتر فعال
        </Typography>
      </Box>

      <Stack gap={1} sx={{ p: { xs: 2, md: 2.5 } }}>
        {/* جستجوی متنی */}
        <Box sx={{ mb: 1 }}>
          <TextField
            fullWidth
            size="small"
            placeholder="جستجوی نام باشگاه..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{ color: "rgba(255,255,255,0.3)", fontSize: 20 }}
                  />
                </InputAdornment>
              ),
            }}
            sx={textFieldStyles}
          />
        </Box>
        <Divider sx={{ borderColor: "rgba(255,255,255,0.06)", mb: 1 }} />

        {/* فیلتر موقعیت مکانی */}
        <FilterSection
          title="موقعیت مکانی"
          icon={
            <LocationOnIcon fontSize="small" sx={{ color: "error.main" }} />
          }
        >
          <Stack gap={2}>
            <Box>
              <Typography
                variant="caption"
                sx={{
                  color: "rgba(255,255,255,0.6)",
                  mb: 0.5,
                  display: "block",
                }}
              >
                استان
              </Typography>
              <Autocomplete
                options={provincesList}
                getOptionLabel={(option) => option?.name || ""}
                value={selectedProvince}
                onChange={(e, newValue) => {
                  setSelectedProvince(newValue);
                  setSelectedCity(null);
                  setSelectedArea(null);
                }}
                autoComplete
                includeInputInList
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="جستجو و انتخاب استان..."
                    sx={textFieldStyles}
                  />
                )}
                noOptionsText="استانی یافت نشد"
              />
            </Box>

            <Box>
              <Typography
                variant="caption"
                sx={{
                  color: "rgba(255,255,255,0.6)",
                  mb: 0.5,
                  display: "block",
                }}
              >
                شهر
              </Typography>
              <Autocomplete
                options={citiesList}
                getOptionLabel={(option) => option?.name || ""}
                value={selectedCity}
                disabled={!selectedProvince}
                onChange={(e, newValue) => {
                  setSelectedCity(newValue);
                  setSelectedArea(null);
                }}
                autoComplete
                includeInputInList
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="جستجو و انتخاب شهر..."
                    sx={textFieldStyles}
                  />
                )}
                noOptionsText="شهری یافت نشد"
              />
            </Box>

            <Box>
              <Typography
                variant="caption"
                sx={{
                  color: "rgba(255,255,255,0.6)",
                  mb: 0.5,
                  display: "block",
                }}
              >
                منطقه / محله
              </Typography>
              <Autocomplete
                options={areasList}
                getOptionLabel={(option) => option?.name || ""}
                value={selectedArea}
                disabled={!selectedCity}
                onChange={(e, newValue) => setSelectedArea(newValue)}
                autoComplete
                includeInputInList
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="جستجو و انتخاب منطقه..."
                    sx={textFieldStyles}
                  />
                )}
                noOptionsText="منطقه‌ای یافت نشد"
              />
            </Box>
          </Stack>
        </FilterSection>

        {/* فیلتر رشته ورزشی */}
        <FilterSection
          title="رشته ورزشی"
          icon={
            <SportsGymnasticsIcon
              fontSize="small"
              sx={{ color: "secondary.main" }}
            />
          }
        >
          <Typography
            variant="caption"
            sx={{ color: "rgba(255,255,255,0.6)", mb: 1, display: "block" }}
          >
            رشته ورزشی باشگاه را انتخاب کنید
          </Typography>
          <Autocomplete
            options={sportsList}
            getOptionLabel={(option) => option?.name || ""}
            value={selectedSport}
            onChange={(e, newValue) => setSelectedSport(newValue)}
            autoComplete
            includeInputInList
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                placeholder="جستجو یا انتخاب رشته..."
                sx={textFieldStyles}
              />
            )}
            noOptionsText="رشته‌ای یافت نشد"
            sx={{ "& .MuiAutocomplete-inputRoot": { p: "3px 8px" } }}
          />
        </FilterSection>

        {/* فیلتر دارای تخفیف */}
        <Box component="section">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              minHeight: 40,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LocalOfferIcon fontSize="small" sx={{ color: "warning.main" }} />
              <Typography
                variant="body2"
                fontWeight={500}
                sx={{ color: "rgba(255,255,255,0.9)" }}
              >
                دارای تخفیف
              </Typography>
            </Box>
            <Switch
              size="small"
              checked={!!isDiscount}
              onChange={(e) =>
                setIsDiscount(e.target.checked == false ? undefined : true)
              }
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "primary.main",
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "primary.main",
                },
              }}
            />
          </Box>
          <Divider sx={{ borderColor: "rgba(255,255,255,0.06)" }} />
        </Box>

        {/* دکمه ریست */}
        <Button
          fullWidth
          variant="text"
          onClick={resetFilters}
          sx={{
            mt: 2,
            textTransform: "none",
            color: "rgba(255,255,255,0.5)",
            fontSize: "0.8125rem",
            "&:hover": {
              color: "error.light",
              backgroundColor: "rgba(244, 67, 54, 0.08)",
            },
          }}
        >
          حذف همه فیلترها
        </Button>
      </Stack>
    </Box>
  );
}
